export {default} from './CashierPaymentsWrapper';



// WEBPACK FOOTER //
// ./CashierPaymentsWrapper/index.ts